/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Brand_Logo_Optional_Printed_On_Back_CoverInputs */

const en_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brand Logo (Optional — Printed on Back Cover)`)
};

const es_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logotipo de la Marca (Opcional - Impreso en la contraportada)`)
};

const fr_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo de la Marque (Facultatif - Imprimé sur la couverture arrière)`)
};

const de_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markenlogo (Optional - Wird auf die Rückseite gedruckt)`)
};

const ja_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブランドロゴ (任意 - 裏表紙に印刷されます)`)
};

const zh_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品牌标志 (可选 - 打印在封底)`)
};

const ar_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شعار العلامة التجارية (اختياري - يُطبع على الغلاف الخلفي)`)
};

const id_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo Merek (Opsional - Dicetak di Sampul Belakang)`)
};

const it_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo del Brand (Opzionale - Stampato sul retro di copertina)`)
};

const ru_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Логотип Бренда (Необязательно - печатается на задней обложке)`)
};

const pt_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logótipo da Marca (Opcional - Impresso na contracapa)`)
};

const ko_brand_logo_optional_printed_on_back_cover = /** @type {(inputs: Brand_Logo_Optional_Printed_On_Back_CoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브랜드 로고 (선택 사항 - 뒤표지에 인쇄됨)`)
};

/**
* | output |
* | --- |
* | "Brand Logo (Optional — Printed on Back Cover)" |
*
* @param {Brand_Logo_Optional_Printed_On_Back_CoverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const brand_logo_optional_printed_on_back_cover = /** @type {((inputs?: Brand_Logo_Optional_Printed_On_Back_CoverInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Brand_Logo_Optional_Printed_On_Back_CoverInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "es") return es_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "fr") return fr_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "de") return de_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "ja") return ja_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "zh") return zh_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "ar") return ar_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "id") return id_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "it") return it_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "ru") return ru_brand_logo_optional_printed_on_back_cover(inputs)
	if (locale === "pt") return pt_brand_logo_optional_printed_on_back_cover(inputs)
	return ko_brand_logo_optional_printed_on_back_cover(inputs)
});